import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import { t } from "../data/translations";
import styles from "./Navbar.module.css";

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const { lang, toggleLang } = useLang();

  const isActive = (path) => location.pathname === path;

  const links = [
    { path: "/", label: t("nav.home", lang) },
    { path: "/about", label: t("nav.about", lang) },
    { path: "/services", label: t("nav.services", lang) },
    { path: "/portfolio", label: t("nav.portfolio", lang) },
    { path: "/contact", label: t("nav.contact", lang) },
  ];

  return (
    <nav className={styles.nav}>
      <div className={styles.navInner}>
        <Link to="/" className={styles.logo}>
          myapple.gr
        </Link>

        <div className={styles.links}>
          {links.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`${styles.link} ${isActive(link.path) ? styles.active : ""}`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className={styles.actions}>
          <motion.button
            className={styles.langToggle}
            onClick={toggleLang}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            title={lang === "en" ? "Αλλαγή σε Ελληνικά" : "Switch to English"}
          >
            {lang === "en" ? "GR" : "EN"}
          </motion.button>

          <div className={styles.burger} onClick={() => setMenuOpen(!menuOpen)}>
            <div className={styles.bar}></div>
            <div className={styles.bar}></div>
            <div className={styles.bar}></div>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className={styles.mobileMenu}
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
          >
            <div className={styles.mobileHeader}>
              <motion.button
                className={styles.langToggleMobile}
                onClick={toggleLang}
                whileTap={{ scale: 0.95 }}
              >
                {lang === "en" ? "🇬🇷 Ελληνικά" : "🇬🇧 English"}
              </motion.button>
              <button
                className={styles.closeBtn}
                onClick={() => setMenuOpen(false)}
              >
                ✕
              </button>
            </div>
            {links.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMenuOpen(false)}
                className={`${styles.mobileLink} ${isActive(link.path) ? styles.active : ""}`}
              >
                {link.label}
              </Link>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
